import React, { useState } from "react";
import { Link } from "react-router-dom";
import Header from "../../../header/header";
import Navvbar from "../../../header/Navvbar";

const AddPermissionGroup = () => {
     const [inputValue, setInputValue] = useState('');

  return (
    <div>
      <Header />
      <Navvbar/>
      <div style={{ width: '95%', margin: '0 auto', padding: "0px" }}>
        <div className="row">
          <div className="col-md-2" style={{ borderRight: '1px solid #004aad', marginTop: "20px" }}>
            <div>
              <h2 style={{ marginLeft: "10px" }}>Settings</h2>
              <div>
                <div style={{ columnCount: 1 }}>
                  <Link to="/Tabs" style={{ textDecoration: 'none', fontSize: '17px', color: " #004aad", marginLeft: "12px" }}>Lab Details</Link>
                </div>
                <div style={{ columnCount: 1 }}>
                  <Link to="/" style={{ textDecoration: 'none', fontSize: '17px', color: " #004aad", marginLeft: "13px" }}>Store</Link>
                </div>
                <div style={{ columnCount: 1 }}>
                  <Link to="/usersetting" style={{ textDecoration: 'none', fontSize: '17px', color: " #004aad", marginLeft: "12px" }}>Users</Link>
                </div>
                <div style={{ columnCount: 1 }}>
                  <Link to="/" style={{ textDecoration: 'none', fontSize: '17px', color: " #004aad", marginLeft: "12px" }}>Permission Groups</Link>
                </div>
                <div style={{ columnCount: 1 }}>
                  <Link to="/Account" style={{ textDecoration: 'none', fontSize: '17px', color: " #004aad", marginLeft: "12px" }}>Accounts</Link>
                </div>
                <div style={{ columnCount: 1 }}>
                  <Link to="/Owerviews" style={{ textDecoration: 'none', fontSize: '17px', color: " #004aad", marginLeft: "12px" }}>Finances</Link>
                </div>
                <div style={{ columnCount: 1 }}>
                  <Link to="/owersetting" style={{ textDecoration: 'none', fontSize: '17px', color: " #004aad", marginLeft: "12px" }}>Case Settings</Link>
                </div>
              </div>
            </div>
          </div>
          <div className="col-10" style={{ marginTop: "18px" }}>
  <h1>Add Permission Group</h1>
  <h3 style={{ fontSize: '18px', marginTop: '20px',color: '#004aad', textDecoration: 'none' }}>
Permission Group Details  </h3>

  <div style={{ 
    borderTop: '3px solid #004aad', 
    backgroundColor: '#f1f1f1', 
    padding: '20px', 
    marginTop: '10px', 
    borderRadius: '4px'
  }}>
    {/* Search Section */}
   <div className="search-section">
  <div className="form-group row align-items-center" style={{ marginBottom: '15px' }}>
    <label className="col-auto" style={{ fontWeight: 'bold', marginBottom: '0' }}>
      Name <span style={{ color: 'red' }}>*</span>
    </label>
    <div className="col-auto">
     <input
      type="text"
      value={inputValue}
      onChange={(e) => setInputValue(e.target.value)}
      placeholder=""
      style={{
        padding: '10px 15px',
        fontSize: '16px',
        borderRadius: '8px',
        border: '1px solid #ccc',
        width: '200px',
        outline: 'none',
        transition: 'border 0.3s ease',
        boxSizing: 'border-box',
        margin: '8px 0',
        ':focus': {
          borderColor: '#4285f4',
          boxShadow: '0 0 0 2px rgba(66, 133, 244, 0.2)'
        }
      }}
    />
    </div>
  </div>
</div>
</div>
  <h2 style={{ fontSize: '18px', marginTop: '20px',color: '#004aad', textDecoration: 'none' }}>
Permissions</h2>

  <div style={{ 
    borderTop: '3px solid #004aad', 
    backgroundColor: '#f1f1f1', 
    padding: '20px', 
    marginTop: '10px', 
    borderRadius: '4px'
  }}>
    {/* Search Section */}
   <div className="search-section">
<div className="form-group row align-items-center" style={{ marginBottom: '15px' }}>
  <ul style={{ listStyleType: 'none', padding: 0 }}>
<div className="form-group row align-items-center" style={{ marginBottom: '15px', display: 'flex', alignItems: 'center' }}>
  <label style={{ fontWeight: 'bold', marginRight: '10px' }}>Dashboard</label>
  <li style={{ margin: '5px 0', display: 'inline-flex', alignItems: 'center' }}>
    <input type="checkbox" defaultChecked /> View Activity Log
  </li>
  <li style={{ margin: '5px 0', display: 'inline-flex', alignItems: 'center' }}>
    <input type="checkbox" defaultChecked /> Manage Partner Labs
  </li>
</div>
<div className="form-group row align-items-center" style={{ marginBottom: '15px', display: 'flex', alignItems: 'center' }}>
  <label style={{ fontWeight: 'bold', marginRight: '10px' }}>Cases</label>
     <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> Manage Partner Labs</li>
    <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> View Case Lists</li>
    <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> Manage Components</li>
    <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> View Calendar</li>
    <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> Manage General Files</li>
    <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> View Procedure Characteristics</li>
    <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> Manage Revenue Centers</li>
    <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> View Revenue Centers</li>
    <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> View Departments</li>
    <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> Manage Locations</li>
    <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> View Tasks</li>
    <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> View Display Categories</li>
    <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> View Procedures</li>
    <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> View Mapping Rules</li>
    <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> Work Ticket Builder</li>
    <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> Manage Mapping Rules</li>
    <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> View Cases</li>
    <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> Location Scanning</li>
    <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> Create Tryin</li>
    <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> Send Cases For Tryin</li>
    <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> Create Cases</li>
    <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> Edit Cases</li>
    <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> Cancel Cases</li>
    <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> Print Work Tickets</li>
    <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> Create Internal Remakes and Next-case Types</li>
    <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> Location Scan Data</li>
    <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> Upload Case Files</li>
    <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> Mark Tasks Complete</li>
    <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> Reschedule Cases</li>
    <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> Use Driver App</li>
    <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> View Estimated Case Value</li>
    <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> View Holidays</li>
    <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> View Internal Remakes and Next-case Types</li>
    <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> View Shipping Types</li>
    <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> Make Case Pickup Requests</li>
</div>
<div className="form-group row align-items-center" style={{ marginBottom: '15px', display: 'flex', alignItems: 'center' }}>
  <label style={{ fontWeight: 'bold', marginRight: '10px' }}>Finances</label>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> Reprint Statements</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> View Statements</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> View Tax Categories</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> View Credit Types</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> Run Statements</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> Enter Starting Balances</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> Create Credit Memos</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> Create Payments</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> Create Invoices</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> Delete Invoices</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> Edit Invoices</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> View Postings</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> Save Invoices As PDF</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> View Invoices</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> Manage Partner Labs</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> View Case Lists</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> Manage Components</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> View Calendar</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> Manage General Files</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> View Procedure Characteristics</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> Manage Revenue Centers</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> View Revenue Centers</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> View Departments</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> Manage Locations</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> View Tasks</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> View Display Categories</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> View Procedures</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> View Mapping Rules</li>
</div>
<div className="form-group row align-items-center" style={{ marginBottom: '15px', display: 'flex', alignItems: 'center' }}>
  <label style={{ fontWeight: 'bold', marginRight: '10px' }}>Promotions</label>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> Manage Coupons</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> Manage Email Campaigns</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> Manage Premium Search</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> Manage Links</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> Manage Widgets</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> Account onboarding features</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> Manage Ads</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> Manage Website</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> Manage Partner Labs</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> View Case Lists</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> Manage Components</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> View Calendar</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> Manage General Files</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> View Procedure Characteristics</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> Manage Revenue Centers</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> View Revenue Centers</li>
</div>
<div className="form-group row align-items-center" style={{ marginBottom: '15px', display: 'flex', alignItems: 'center' }}>
  <label style={{ fontWeight: 'bold', marginRight: '10px' }}>Reports</label>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> View Shipping Report</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> View Tagged Cases Report</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> View Sales Comparison Report</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> View Procedures Comparison Report</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> View New Cases Report</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> View New Accounts Report</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> View Case Files Report</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> View Price Lists Report</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> View DDX Analytics</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> View Process Improvement Report</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> Case Turn Around Time</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> View Procedures Setup Report</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> View Cases Cancellation Report</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> View Completed Tasks Report</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> View Revenue Centers Report</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> View Case Tags Report</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> View Task Cycle Timing Report</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> View Credit Limits Report</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> Manage On Hold Types</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> View Internal Remarks and Next-Case Reports</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> View Money Owed Report</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> View Sales Report</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> View Customer Sales and Invoiced Items Report</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> View Product and Alloy Sales Report</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> View Sales Reps Report</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> View Payments By Accounts Report</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> View Unit Sales Analysis By Account Report</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> View Unit Sales Analysis By Product Report</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> View Patient Report</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> View Component Sales Report</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> View Incomplete Tasks Report & Print Model Labels</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> View Technician Pay Per Task Report</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> Manage Rx Terms</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> View Cases Shipped Report</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> View Procedures Taxes Report</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> View Accounts Taxes Report</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> Batch Print Work Tickets</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> View Revenue Outlook Report</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> View Procedure Quick Code Report</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> View Account Quick Code Report</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> View Taxes Report</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> View Revenue By Payment Method Report</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> Batch Print Invoices</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> View Process Payment Report</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> Manage Partner Labs</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> View Case Lists</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> Manage Components</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> View Calendar</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> Manage General Files</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> View Procedure Characteristics</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> Manage Revenue Centers</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> View Revenue Centers</li>
</div>
<div className="form-group row align-items-center" style={{ marginBottom: '15px', display: 'flex', alignItems: 'center' }}>
  <label style={{ fontWeight: 'bold', marginRight: '10px' }}>Settings</label>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> Manage Instructions</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked /> Edit Users</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked/> Modify Tasks</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked/> Manage Scheduling/Holidays</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked/> Manage Identification and Traceability</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked/> Add Users</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked/> Manage Canceled Case Reasons</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked/> Modify Internal Remakes and Next-case Types</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked/> Modify Procedure Characteristics</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked/> Modify Shipping Types</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked/> Modify Procedures</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked/> Manage Accounts - requires View Accounts List and Details</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked/> View Accounts List and Details</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked/> Manage Credit Memo Types</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked/> Modify Departments</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked/> View Users</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked/> Manage Lab Details</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked/> Use Global Search</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked/> Manage Display Categories</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked/> Manage Partner Labs</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked/> View Case Lists</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked/> Manage Components</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked/> View Calendar</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked/> Manage General Files</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked/> View Procedure Characteristics</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked/> Manage Revenue Centers</li>
  <li style={{ margin: '5px 0' }}><input type="checkbox" defaultChecked/> View Revenue Centers</li>
</div>
<div>
    <button
        type="button"
        style={{
          backgroundColor: "#004aad",
          color: "#fff",
          fontWeight: "600",
          padding: "0.5rem 1rem",
          borderRadius: "0.5rem",
          border: "none",
          cursor: "pointer",
          transition: "background-color 0.3s",
        }}
        onMouseOver={(e) => (e.target.style.backgroundColor = "#003b8f")}
        onMouseOut={(e) => (e.target.style.backgroundColor = "#004aad")}
      >
        Save
      </button>
</div>
 
  </ul>
</div>
</div>
</div>
        
             
 

 
        
          </div>
        </div>
      </div>
    </div>
    
  );
};

export default AddPermissionGroup;
